import { Component, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { AbstractFormComponent } from '@shared/components/abstracts/abstract-form.component';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AccountService } from '@shared/services/account.service';
import { AuthService } from '@shared/services/auth.service';
import { StateType } from '@shared/enums/state-type';
import { ToastService } from '@shared/services/toast.service';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sign-in',
  imports: [RouterLink, ReactiveFormsModule, NgIf, TranslateModule],
  templateUrl: './sign-in.component.html',
})
export class SignInComponent extends AbstractFormComponent {
  isInvalidSignInMessage?: string;

  environmentConfig = inject(ENVIRONMENT_CONFIG);
  routesPath = this.environmentConfig.routes;

  constructor(
    private accountService: AccountService,
    private authService: AuthService,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {
    const form = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/),
      ]),
      password: new FormControl('', [Validators.required]),
    });
    super(form);
  }

  protected override onSubmit(): boolean {
    const email = this.formGroup.get('email');
    const password = this.formGroup.get('password');
    if (super.onSubmit() && email && password) {
      this.accountService
        .signInAccount({
          email: email.value,
          password: password.value,
        })
        .subscribe(
          item => {
            this.authService.signIn(item);
          },
          err => {
            if (err.status >= 400 && err.status < 500) {
              this.isInvalidSignInMessage = err.error.error.message;
            } else {
              this.toastService.addToast({
                type: StateType.DANGER,
                title: this.translateService.instant(
                  'COMMON.TOAST.ERROR.TITLE'
                ),
                message: this.translateService.instant(
                  'COMMON.TOAST.ERROR.MESSAGE'
                ),
              });
            }
            this.onDisabled(false);
          }
        );
      return true;
    }
    return super.onSubmit();
  }
}
